module.exports = __webpack_public_path__ + "img/dettaglio chiavi.a4904300.jpeg";